// extracted by mini-css-extract-plugin
export var activeFilterButton = "_n5-c";
export var backButton = "_n5-4";
export var backIcon = "_n5-5";
export var chevronShortcut = "_n5-6";
export var container = "_n5-1";
export var editor = "_n5-8";
export var editorWrapper = "_n5-7";
export var prefix = "_n5-2";
export var searchIcon = "_n5-3";
export var suffix = "_n5-9";
export var suffixContent = "_n5-a";
export var suffixText = "_n5-b";
export var wrapper = "_n5-0";